// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { Dropdown } from 'ui_kit_qmd'
import './VisitsPageTools.scss'
import { tableViewOptions } from '../../../utils/constants'

const selectVisitTypeDropdownContainerStyle = {
  width: 155,
  height: 42,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  border: '1px solid #C2D5E2',
  borderStyle: 'solid',
  background: '#FFFFFF',
  marginLeft: 0,
  paddingLeft: 0,
}
const selectVisitTypeDropdownListContainerStyle = {
  width: 154,
  marginTop: 6,
  height: 88,
}
const selectVisitTypeDropdownIconStyle = {
  top: 12,
  right: 13,
}
const selectVisitTypeDropdownInputStyle = {
  padding: 0,
  margin: '0px 0px 0px 10px',
  height: 28,
  width: 90,
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const VisitsPageTools = memo(({ tableView, setTableView, onSelectDropdownCallback }) => (
  <div className='visit-page-tool-block'>
    <Dropdown
      options={tableViewOptions}
      onSelectCallback={onSelectDropdownCallback}
      isWithoutLabel
      containerStyle={selectVisitTypeDropdownContainerStyle}
      customIconStyles={selectVisitTypeDropdownIconStyle}
      inputStyle={selectVisitTypeDropdownInputStyle}
      dropdownContainerStyle={selectVisitTypeDropdownListContainerStyle}
      value={tableView}
      setValue={setTableView}
      dropId='ViewDropDown'
      label=''
    />
  </div>
))
